// SPAREPE "Who am I?" theme: light grey page, white content, accent blue
export const ONBOARDING_THEME = {
  pageBg: '#F5F5F5',
  contentBg: '#ffffff',
  accent: '#64B5F6',
  accentDark: '#42A5F5',
  text: '#212121',
  textMuted: '#616161',
  textLight: '#9e9e9e',
  border: '#e0e0e0',
  borderLight: '#eeeeee',
  shadow: '0 2px 12px rgba(0,0,0,0.08)',
  shadowCard: '0 4px 20px rgba(0,0,0,0.06)',
  radius: '12px',
  radiusSm: '8px',
  error: '#c62828',
  errorLight: '#ffebee',
  success: '#2e7d32',
  accentLight: '#E3F2FD',
  inputBg: '#fafafa',
};
